import { render, staticRenderFns } from "./VolumeUpIcon.vue?vue&type=template&id=1dd058f0&"
import script from "./VolumeUpIcon.vue?vue&type=script&lang=js&"
export * from "./VolumeUpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports